import React, { useState } from "react";

import {
  useNotify,
  useRedirect,
  Create,
  TopToolbar,
  Toolbar,
  SaveButton,
  SimpleForm,
  TextInput,
  Button,
} from "react-admin";

import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { AuditStatus } from "../../../utils/constants";
import { AuditMap } from "../../../crewApp/pages/locationSearch/Locations";
import LocationsMap from "../../../crewApp/pages/audit/LocationsMap";
import { logError } from "../../../utils/appUtils";
import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { HelpButton } from "../../../components/common/HelpButton";
import { AuditCreateHelp } from "./AuditHelp";

import {
  CancelIcon,
  EditLocationIcon,
  SetLocationIcon,
} from "../../../components/common/iconography";

const useStyles = makeStyles((theme) => ({
  accounts: { marginBottom: theme.spacing(1) },
  button: {
    [theme.breakpoints.up("sm")]: {
      marginTop: theme.spacing(0.5),
    },
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      marginBottom: theme.spacing(1),
    },
  },
  dialogContent: {
    // https://stackoverflow.com/questions/47698037/how-can-i-set-a-height-to-a-dialog-in-material-ui
    height: "90vh",
  },
}));

const AuditCreateForm = ({
  order,
  auditAccount,
  auditLocations,
  setOrder,
  setAuditAccount,
  setAuditLocations,
  ...props
}) => {
  const classes = useStyles();
  const [locationOpen, setLocationOpen] = useState(false);
  const [oldAccount, setOldAccount] = useState("All accounts");
  const [oldLocations, setOldLocations] = useState([]);
  const [locations, setLocations] = useState([]);
  const blankAudit = { id: "blank", processedLocations: [] };

  const handleMapOpen = () => {
    setOldAccount(auditAccount);
    setOldLocations(auditLocations);
    setLocationOpen(true);
  };
  const handleConfirm = () => {
    handleOrder(order);
    setLocationOpen(false);
  };
  const handleCancel = () => {
    setAuditAccount(oldAccount);
    setAuditLocations(oldLocations);
    setLocationOpen(false);
  };
  const handleOrder = (value) => {
    debugger;
    let newWorldOrder = auditLocations;
    setOrder(value);
    if (value === "ASC")
      newWorldOrder.sort((a, b) => (a.sortKey > b.sortKey ? 1 : -1));
    else newWorldOrder.sort((a, b) => (a.sortKey < b.sortKey ? 1 : -1));
    setAuditLocations(newWorldOrder);
    setLocations(newWorldOrder);
  };

  return (
    <Grid container item direction="column" spacing={1} lg={8}>
      <Grid container direction="row" spacing={1} alignItems="center">
        <Grid item xs={12} md={6}>
          <TextField
            label="Account"
            variant="outlined"
            margin="dense"
            fullWidth
            className={classes.accounts}
            disabled={true}
            value={auditAccount?.businessName || ""}
          />
        </Grid>
        <Grid item xs={12} md={6} className={classes.button}>
          <Button label="Set Account" size="medium" onClick={handleMapOpen}>
            <EditLocationIcon />
          </Button>
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12}>
          <Typography variant="overliine"> Location Map </Typography>
        </Grid>
        <Grid item xs={12}>
          <LocationsMap
            currentAudit={blankAudit}
            locations={locations.map((itm) => itm.id)}
          />
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={false}>
          <Dialog
            open={locationOpen}
            maxWidth="lg"
            onClose={handleCancel}
            fullWidth
          >
            <DialogTitle id="create-audit">Select Audit Account</DialogTitle>
            <DialogContent dividers className={classes.dialogContent}>
              <AuditMap
                setAuditAccount={setAuditAccount}
                setAuditLocations={setAuditLocations}
              />
            </DialogContent>
            <DialogActions>
              <Button label="CANCEL" color="default" onClick={handleCancel}>
                <CancelIcon />
              </Button>
              <Button
                label="SET LOCATIONS"
                color="primary"
                onClick={handleConfirm}
              >
                <SetLocationIcon />
              </Button>
            </DialogActions>
          </Dialog>
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12}>
          <TextInput
            source="notes"
            variant="outlined"
            multiline
            minRows={3}
            fullWidth
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

const AuditCreateActions = ({ basePath, ...props }) => (
  <TopToolbar>
    <HelpButton>
      <AuditCreateHelp {...props} />
    </HelpButton>
    <BackButton basePath={basePath} />
  </TopToolbar>
);

export const AuditCreate = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();

  const [order, setOrder] = useState("ASC");
  const [auditAccount, setAuditAccount] = useState({
    id: null,
    name: "All accounts",
  });
  const [auditLocations, setAuditLocations] = useState([]);
  debugger;

  const AuditCreateToolbar = (props) => {
    const { basePath } = props;

    const transform = (data) => {
      data.active = "true";
      data.status = AuditStatus.IN_PROGRESS;
      data.groups = window.appUser?.groups;
      data.createDateTime = new Date();
      data.reloadYardId = window.appUser?.reloadYardId;
      data.accountId = auditAccount.id;
      data.accountName = auditAccount.businessName;
      data.locations = auditLocations.map((itm) => itm.id);
      data.direction = order;
      data.skippedItems = "[]";
      data.processedItems = "[]";
      data.processedLocations = "{}";
      data.nextItem = 0;
      data.nextItems = [];

      debugger;

      return { ...data };
    };

    const onSuccess = (data) => {
      debugger;
      notify("Audit created successfully.");
      redirect(basePath);
    };

    const onFailure = (error) => {
      logError("audits:AuditCreate:onFailure", error, notify);
    };

    return (
      <Toolbar {...props}>
        <SaveButton
          {...props}
          disabled={auditLocations.length < 1}
          transform={transform}
          onSuccess={onSuccess}
          onFailure={onFailure}
        />
      </Toolbar>
    );
  };

  return (
    <Create
      {...props}
      title={<ForceTitle title="New Audit" />}
      actions={<AuditCreateActions {...props} />}
    >
      <SimpleForm
        variant="outlined"
        submitOnEnter={false}
        toolbar={<AuditCreateToolbar />}
      >
        <AuditCreateForm
          order={order}
          auditAccount={auditAccount}
          auditLocations={auditLocations}
          setOrder={setOrder}
          setAuditAccount={setAuditAccount}
          setAuditLocations={setAuditLocations}
        />
      </SimpleForm>
    </Create>
  );
};
